/*
 * @Author: your name
 * @Date: 2021-12-13 11:06:09
 * @LastEditTime: 2021-12-28 16:23:13
 * @LastEditors: Please set LastEditors
 * @Description: 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 * @FilePath: /theEventsEditor/projects/events-editor/src/lib/command-source/internals/internals.component.ts
 */
import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { EventsEditorUtil } from '../../../events-editor-utils';
import { IdService } from '@farris/ui-common';
import { cloneDeep } from 'lodash-es'
@Component({
  selector: 'farris-internals',
  templateUrl: './internals.component.html',
  styleUrls: ['./internals.component.css']
})
export class InternalsComponent implements OnInit {
  /** 中文或英文环境标识 */
  @Input() localeId: string;
  /** 当前显示的是第几个事件 */
  @Input() i: number;
  /** 入参 */
  @Input() initialData: any;
  /** 原层级结构数据 */
  @Input() originalData: any;
  /**传出用户选择绑定的方法 */
  @Output() currentCommandChanged = new EventEmitter<any>();
  /** 传出数据变化 */
  @Output() originalDataChanged = new EventEmitter<any>();

  constructor(private idService: IdService,) { }

  ngOnInit() {
  }

  /** 生成不重复的方法名 */
  public generateFunctionName(suffix, viewModelId, code) {
    let newName = `${viewModelId}${code}${suffix}`;
    let repitition = -1;
    const viewModelDisplay = this.initialData.getEventPath().viewModelDisplay;
    // 循环直到生成不重复的方法名
    while (repitition == -1) {
      let commandNameExist = false;
      // this.initialData.viewModel
      for (let i = 0; i < viewModelDisplay.length; i++) {
        viewModelDisplay[i].controllerList.forEach(commandItem => {
          if (commandItem.label || commandItem.label == '') {
            commandNameExist = commandItem.label.toLowerCase() == newName.toLowerCase() ? true : commandNameExist;
          }
          else {
            commandNameExist = false;
          }
        })
      }

      if (commandNameExist) {
        suffix += 1;
        newName = `${viewModelId}${code}${suffix}`;
      }
      else {
        repitition = 0;
        break;
      }
    }
    return newName;
  }
  /** 
   *  1. 根据用户选择的方法生成新的方法id及label
   *     比如：首先生成：前缀+方法名+1，
   *     与现有视图模型存储方法的id比对，若发现已有，则生成：前缀+方法名+2，以此类推；
   *     直到新生成的这个方法的id不与任何方法重复，则将其存入currentCommand；
   *  2. 存入视图模型；
   *  */
  public selectCommandChanged(command, controller) {
    this.initialData['preCommand'] = cloneDeep(this.originalData[this.i].currentCommand);
    // 根据用户选择的方法生成新的方法名
    const viewModelId = this.initialData.viewModelId.replace(/-/g, '').replace('component', '').replace('viewmodel', '');
    let suffix = 1;
    const code = command.label.slice(0, 1).toUpperCase() + command.label.slice(1);
    const newName = this.generateFunctionName(suffix, viewModelId, code);

    let newCommand = {
      id: this.idService.generate(),
      label: newName,
      name: `${command.name}${suffix}`,
      handlerName: command.handlerName,
      cmpId: command.cmpId,
      componentLists: [],
      hasPath: false,
      targetComponent: undefined,
      property: cloneDeep(command.property),
      shortcut: {},
      isRTCmd: command['isRTCmd'],
      isNewGenerated: true,
      extensions: [],
      isInvalid: false,
    }
    const viewModelData = cloneDeep(this.initialData.viewModel);
    const internalsData = cloneDeep(this.originalData[this.i].internalCommandList);
    newCommand = EventsEditorUtil.setComponentLists(controller, newCommand, this.initialData)
    this.originalData[this.i].currentCommand = cloneDeep(newCommand);
    this.originalData[this.i].currentControllerName = cloneDeep(controller.controllerName);
    // 2.存入视图模型对应的控制器
    internalsData.forEach(internalsDataItem => {
      //在对应控制器下寻找
      if (internalsDataItem.controllerName.label == controller.controllerName.label) {
        //找到用户的选择方法，存入视图模型；
        internalsDataItem.controllerList.forEach(function (controllerListItem) {
          if (controllerListItem.label == command.label) {
            /** savedCommand框架 */
            let savedCommandFrame = {
              /** 控制器名称 */
              controllerName: {
                id: '',
                /** 控制器编号 */
                label: '',
                /**控制器中文名 */
                name: ''
              },
              /** 当前控制器下的方法列表 */
              controllerList: [],
            }
            //视图模型对应值存储
            let controllerExists = viewModelData.find(item => (item.controllerName.label == controller.controllerName.label))
            //没有存储过控制器
            if (!controllerExists) {
              //在事件下，push该控制器及方法
              savedCommandFrame.controllerName = {
                id: controller.controllerName.id,
                label: controller.controllerName.label,
                name: controller.controllerName.name,
              }
              //将方法push到事件-控制器-方法列表下
              savedCommandFrame.controllerList.push(cloneDeep(newCommand));
              viewModelData.push(cloneDeep(savedCommandFrame));
            }
            //已存储过该控制器；
            else {
              let commandExists = controllerExists.controllerList.find(item => (item.label == command.label))
              //已存储过该控制器-存储过该方法
              if (commandExists) {
                commandExists.property = cloneDeep(command.property);
              }
              //已存储过该控制器-未存储过该方法
              else {
                //在对应控制器下，push该方法
                controllerExists.controllerList.push(cloneDeep(newCommand));
              }
            }
          }
        })
      }
    })
    this.initialData.viewModel = cloneDeep(viewModelData);
    this.originalData[this.i].internalCommandList = cloneDeep(internalsData);
    this.originalData[this.i] = cloneDeep(this.originalData[this.i]);
    this.originalDataChanged.emit(this.originalData)
    this.currentCommandChanged.emit(this.originalData[this.i].currentCommand);
  }
}
